import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiGoogleSession } from "@/lib/falApi";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const { user } = await apiGoogleSession(sessionId);
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#0a0a0a] grid place-items-center text-white">
      <div className="text-center">
        <Loader2 className="h-6 w-6 text-[#faff69] animate-spin mx-auto" />
        <p className="mt-3 text-sm text-zinc-400">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
